import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { UserResponseDto } from '@sphere/user/domain';
import { ActivitySummaryDto } from './activity-summary.dto';

export class ActivityUserAssignmentResponseDto {
  @ApiProperty({ type: 'string' })
  id!: string;

  @ApiProperty({ type: 'string' })
  activityId!: string;

  @ApiPropertyOptional({ type: () => ActivitySummaryDto })
  activity?: ActivitySummaryDto;

  @ApiProperty({ type: () => UserResponseDto })
  user!: UserResponseDto;

  @ApiPropertyOptional({ type: 'string', nullable: true })
  schoolYearCode!: string | null;

  @ApiPropertyOptional({ type: 'string', format: 'date-time', nullable: true })
  availableFrom!: string | Date | null;

  @ApiPropertyOptional({ type: 'string', format: 'date-time', nullable: true })
  dueAt!: string | Date | null;

  @ApiPropertyOptional({ type: Number, nullable: true })
  maxAttempts!: number | null;

  @ApiPropertyOptional({ type: Boolean, nullable: true })
  showSolutions!: boolean | null;
}
